import { useEffect, useState } from 'react'
import { Button, Expandable } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { CaseFormSection } from '..'
import { AdditionalFamilyInput } from 'components/dashboard/CaseDetails/CaseInputWrappers'
import {
  M3FamilyInfoFields,
  M3GenealogyFields,
} from 'components/dashboard/CaseDetails/M3FamilySections'
import { caseFormSectionsLabels } from '@messenger/consts'
import { useTranslation } from 'react-i18next'
import { useIsM3Order } from '@/hooks/utility/useIsM3Order'

export const DeceasedInfo = ({ saveCase, setActiveTab, activeTab }) => {
  const [expandedPersonal, setExpandedPersonal] = useState(true)
  const [expandedFamily, setExpandedFamily] = useState('')
  const [expandedAdditionalFamily, setExpandedAdditionalFamily] = useState('')
  const [expandedGenealogy, setExpandedGenealogy] = useState('')
  const { t } = useTranslation()
  // M3 orders get the m3-style sections (flat additional-family input, date
  // of marriage, genealogy); MDL orders keep the original three sections.
  // Derived from product source, not applicationType — master orders opened
  // from MDL carry M3 products while the atom stays 'MDL'.
  const isM3Order = useIsM3Order()

  useEffect(() => {
    setExpandedPersonal(true)
    setExpandedFamily(false)
    setExpandedAdditionalFamily(false)
    setExpandedGenealogy(false)
  }, [activeTab])

  const saveAndContinue = (expanded) => {
    switch (expanded) {
      case 'personalInfo':
        setExpandedPersonal(false)
        setExpandedFamily(true)
        break
      case 'familyInfo':
        setExpandedFamily(false)
        setExpandedAdditionalFamily(true)
        break
      case 'additionalFamily':
        if (isM3Order) {
          setExpandedAdditionalFamily(false)
          setExpandedGenealogy(true)
          break
        }
        setExpandedPersonal(false)
        setExpandedFamily(false)
        setExpandedAdditionalFamily(false)
        setActiveTab(t('caseDetails.tabs.obituary.title'))
        break
      case 'genealogy':
        setExpandedPersonal(false)
        setExpandedFamily(false)
        setExpandedAdditionalFamily(false)
        setExpandedGenealogy(false)
        setActiveTab(t('caseDetails.tabs.obituary.title'))
        break
      default:
        //for now collapse all
        setExpandedPersonal(false)
        setExpandedFamily(false)
        setExpandedAdditionalFamily(false)
        setExpandedGenealogy(false)
    }
    saveCase()
  }

  const saveAndContinueButton = (section) => (
    <Flex justify="flex-end">
      <Button primary onClick={() => saveAndContinue(section)}>
        {t('caseDetails.saveAndContinueButton')}
      </Button>
    </Flex>
  )

  return (
    <Flex column full padding="0 48px 0 0">
      <Flex column align="flex-start">
        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.deceasedInfo.personalInfo')}
          show={[expandedPersonal, setExpandedPersonal]}
          full
        >
          <CaseFormSection
            formSection="personalInfo"
            saveAndContinue={saveAndContinue}
          />
        </Expandable>

        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.deceasedInfo.familyInfo')}
          show={[expandedFamily, setExpandedFamily]}
          full
        >
          {isM3Order ? (
            <>
              <M3FamilyInfoFields />
              {saveAndContinueButton('familyInfo')}
            </>
          ) : (
            <CaseFormSection
              formSection="familyInfo"
              saveAndContinue={saveAndContinue}
            />
          )}
        </Expandable>
        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.deceasedInfo.additionalFamilyInfo')}
          show={[expandedAdditionalFamily, setExpandedAdditionalFamily]}
          full
        >
          {isM3Order ? (
            <>
              <AdditionalFamilyInput width="100%" margin="0 24px 24px 24px" />
              {saveAndContinueButton('additionalFamily')}
            </>
          ) : (
            <CaseFormSection
              formSection="additionalFamily"
              saveAndContinue={saveAndContinue}
            />
          )}
        </Expandable>
        {isM3Order && (
          <Expandable
            margin="0 0 32px 0"
            title={t('caseDetails.tabs.deceasedInfo.genealogy', {
              defaultValue: caseFormSectionsLabels.genealogy,
            })}
            show={[expandedGenealogy, setExpandedGenealogy]}
            full
          >
            <M3GenealogyFields />
            {saveAndContinueButton('genealogy')}
          </Expandable>
        )}
      </Flex>
    </Flex>
  )
}

export default DeceasedInfo
